import { client } from "./client";
import { Measurable, MeasurableCreateRequest, MeasurableUpdateRequest, ScenarioCreateRequest, ScenarioUpdateRequest } from "../types/Scenario";

export function apiCreateScenario(
  organizationId: number,
  workspaceId: number,
  scenarioCreateRequest: ScenarioCreateRequest
) {
  const body = {
    ...scenarioCreateRequest,
    parent_scenario_id: scenarioCreateRequest.parent_scenario_id ?? -1,
    folder_id: scenarioCreateRequest.folder_id ?? null,
    priority: scenarioCreateRequest.priority ?? 0,
  };
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/scenarios`,
    body
  );
}

export function apiUpdateScenario(
  organizationId: number,
  workspaceId: number,
  scenarioId: number,
  scenarioUpdateRequest: ScenarioUpdateRequest
) {
  const body = {
    ...scenarioUpdateRequest,
    parent_scenario_id: scenarioUpdateRequest.parent_scenario_id ?? -1,
    folder_id: scenarioUpdateRequest.folder_id ?? null,
    priority: scenarioUpdateRequest.priority ?? 0,
  };
  return client.put(
    `/organizations/${organizationId}/workspaces/${workspaceId}/scenarios/${scenarioId}`,
    body
  );
}

export function apiGetScenarioMeasurables(
  organizationId: number,
  workspaceId: number,
  scenarioId: number
): Promise<{ data: { measurables?: Measurable[] } }> {
  return client.get(
    `/organizations/${organizationId}/workspaces/${workspaceId}/scenarios/${scenarioId}/measurables`
  );
}

export function apiCreateScenarioMeasurable(
  organizationId: number,
  workspaceId: number,
  scenarioId: number,
  measurableCreateRequest: MeasurableCreateRequest
) {
  const { deps, dash_id, priority, for_whom, ...rest } = measurableCreateRequest;
  const body = {
    ...rest,
    deps: JSON.stringify({ deps: deps ?? [] }),
    dash_id: dash_id ?? null,
    priority: priority ?? 0,
    for_whom: for_whom ?? "[]",
  };
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/scenarios/${scenarioId}/measurables`,
    body
  );
}

export function apiUpdateScenarioMeasurable(
  organizationId: number,
  workspaceId: number,
  scenarioId: number,
  measurableId: number,
  measurableUpdateRequest: MeasurableUpdateRequest
) {
  const { deps, dash_id, priority, for_whom, ...rest } = measurableUpdateRequest;
  const body = {
    ...rest,
    deps: JSON.stringify({ deps: deps ?? [] }),
    dash_id: dash_id ?? null,
    priority: priority ?? 0,
    for_whom: for_whom ?? "[]",
  };
  return client.put(
    `/organizations/${organizationId}/workspaces/${workspaceId}/scenarios/${scenarioId}/measurables/${measurableId}`,
    body
  );
}
